"use client"

import { useState, useEffect } from "react"

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isSticky, setIsSticky] = useState(false)
  const [activeSection, setActiveSection] = useState("home")

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 100)

      const sections = document.querySelectorAll("section")
      const scrollY = window.scrollY

      sections.forEach((sec) => {
        const offset = sec.offsetTop - 150
        const height = sec.offsetHeight
        const id = sec.getAttribute("id")

        if (scrollY >= offset && scrollY < offset + height) {
          setActiveSection(id)
          sessionStorage.setItem("activeSection", id)
        }
      })

      setIsMenuOpen(false)
    }

    window.addEventListener("scroll", handleScroll)


    const savedSection = sessionStorage.getItem("activeSection")
    if (savedSection) {
      setTimeout(() => {
        const el = document.getElementById(savedSection)
        if (el) {
          el.scrollIntoView({ behavior: "smooth" })
        }
      }, 100)
    }

    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const handleNavClick = (sectionId) => {
    setActiveSection(sectionId)
    setIsMenuOpen(false)

    const el = document.getElementById(sectionId)
    if (el) {
      el.scrollIntoView({ behavior: "smooth" })
      window.history.replaceState(null, "", window.location.pathname)
    }
  }

  const navItems = [
    { label: "About", id: "home" },
    { label: "Skills", id: "skills" },
    { label: "Experience", id: "experience" },
    { label: "Education", id: "education" },
    { label: "Projects", id: "projects" },
    { label: "Activities", id: "activities" },
    { label: "Cherished One", id: "cherished" },
    { label: "Contact", id: "contact" },
  ]

  return (
    <header
      className={`fixed top-0 left-0 w-full px-[9%] py-8 bg-bg-primary flex justify-between items-center z-50 transition-all duration-300 ${isSticky ? "shadow-lg" : ""
        }`}
    >
      <a
        href="https://sriramgandrothu.netlify.app/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-4xl md:text-[2.5rem] text-text-primary font-bold cursor-pointer"
      >
        Sri Ram
      </a>

      <button
        className="text-[3.6rem] text-white lg:hidden transition-all duration-300"
        onClick={toggleMenu}
      >
        <i className={`fa-solid ${isMenuOpen ? "fa-circle-xmark" : "fa-caret-down"}`}></i>
      </button>

      <nav
        className={`${isMenuOpen ? "block" : "hidden"
          } lg:block absolute lg:relative top-full lg:top-0 left-0 lg:left-auto w-full lg:w-auto px-[3%] lg:px-0 py-4 lg:py-0 bg-bg-primary lg:bg-transparent border-t lg:border-t-0 border-black/20 shadow-lg lg:shadow-none`}
      >
        {navItems.map((item) => (
          <button
            key={item.id}
            onClick={() => handleNavClick(item.id)}
            className={`block lg:inline text-[2rem] lg:text-[1.4rem] font-bold my-12 lg:my-0 lg:ml-16 transition-colors duration-300 ${activeSection === item.id ? "text-accent" : "text-white hover:text-accent"
              }`}
            type="button"
          >
            {item.label}
          </button>
        ))}
      </nav>
    </header>
  )
}

export default Header
